export default "__VITE_ASSET__CKDPbHi2__"